import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router";

import GuestRoute from "./GuestRoute";
import AuthRoute from "./AuthRoute";
import AdminRoute from "./AdminRoute";

import { store } from "../Store/Store";
import { Provider } from "react-redux";

import Login from "../Pages/Auth/Login";
import Signup from "../Pages/Auth/Signup";
import Dashboard from "../Pages/Admin/Dashboard";
import SpotDetails from "../Pages/SpotDetails";
import HomePage from "../Pages/HomePage";
import UsersList from "../Pages/Admin/UsersList.js";
import SpotsList from "../Pages/Admin/SpotsList.js";
import PaymentsList from "../Pages/Admin/PaymentsList.js";
import VehiclesList from "../Pages/Admin/VehiclesList.js";
import AppVersionSettings from "../Pages/Admin/AppVersionSettings.js";

import UserSpotsList from "../Pages/User/SpotsList.js";
import UserPaymentsList from "../Pages/User/PaymentsList.js";
import UserVehiclesList from "../Pages/User/VehiclesList.js";
import SpotBooking from "../Pages/SpotBooking.js";
import BookingDetails from "../Pages/BookingDetails.js";
import BookingsList from "../Pages/Admin/BookingsList.js";
import UserBookingsList from "../Pages/User/BookingsList.js";
import UserRequestsList from "../Pages/User/RequestsList.js";
import UserProfile from "../Pages/User/Profile.js";
import NotFound from "../Pages/NotFound.js";
import CookieBanner from "../Pages/Component/CookieBanner.js";
import LandingDC from "../Pages/Landing/DC.js";
import LandingNYC from "../Pages/Landing/NYC.js";

const AppRoutes = () => {
  const router = createBrowserRouter([
    { path: "/", element: <GuestRoute component={Login} /> },
    { path: "/login", element: <GuestRoute component={Login} /> },
    { path: "/signup", element: <GuestRoute component={Signup} /> },
    { path: "/admin/", element: <AdminRoute component={SpotsList} /> },
    { path: "/admin/spots", element: <AdminRoute component={SpotsList} /> },
    { path: "/admin/spots/page/:page", element: <SpotsList /> },
    // { path: "/admin/users", element: <AdminRoute component={UsersList} /> },
    { path: "/admin/users", element: <AdminRoute component={UsersList} /> },
    {
      path: "/admin/users/page/:page",
      element: <AdminRoute component={UsersList} />,
    },
    {
      path: "/admin/payments",
      element: <AdminRoute component={PaymentsList} />,
    },
    {
      path: "/admin/payments/page/:page",
      element: <AdminRoute component={PaymentsList} />,
    },
    {
      path: "/admin/vehicles",
      element: <AdminRoute component={VehiclesList} />,
    },
    {
      path: "/admin/vehicles/page/:page",
      element: <AdminRoute component={VehiclesList} />,
    },
    {
      path: "/admin/bookings",
      element: <AdminRoute component={BookingsList} />,
    },
    {
      path: "/admin/bookings/page/:page",
      element: <AdminRoute component={BookingsList} />,
    },
    {
      path: "/admin/app-versions",
      element: <AdminRoute component={AppVersionSettings} />,
    },

    { path: "/user", element: <AuthRoute component={UserSpotsList} /> },
    { path: "/user/spots", element: <AuthRoute component={UserSpotsList} /> },
    {
      path: "/user/spots/page/:page",
      element: <AuthRoute component={UserSpotsList} />,
    },
    {
      path: "/user/payments",
      element: <AuthRoute component={UserPaymentsList} />,
    },
    {
      path: "/user/payments/page/:page",
      element: <AuthRoute component={UserPaymentsList} />,
    },
    {
      path: "/user/vehicles",
      element: <AuthRoute component={UserVehiclesList} />,
    },
    {
      path: "/user/vehicles/page/:page",
      element: <AuthRoute component={UserVehiclesList} />,
    },
    {
      path: "/user/bookings",
      element: <AuthRoute component={UserBookingsList} />,
    },
    {
      path: "/user/bookings/page/:page",
      element: <AuthRoute component={UserBookingsList} />,
    },
    {
      path: "/user/requests",
      element: <AuthRoute component={UserRequestsList} />,
    },
    {
      path: "/user/profile",
      element: <AuthRoute component={UserProfile} />,
    },

    { path: "/spot/:spotId", element: <GuestRoute component={SpotDetails} /> },
    {
      path: "/booking/:spotId",
      element: <GuestRoute component={SpotBooking} />,
    },
    {
      path: "/active-booking/:bookingId",
      element: <GuestRoute component={BookingDetails} />,
    },
    { path: "/dc", element: <LandingDC /> },
    { path: "/nyc", element: <LandingNYC /> },

    { path: "*", element: <NotFound /> },
  ]);

  return (
    <Provider store={store}>
      <RouterProvider router={router} />
      <CookieBanner />
    </Provider>
  );
};

export default AppRoutes;
